<template>
  <div class="min-h-screen bg-gray-100 pb-20">
    <div class="max-w-[600px] mx-auto">
      
      <!-- Header -->
      <div class="bg-white sticky top-0 z-10 shadow-sm">
        <div class="flex items-center gap-3 p-4">
          <button @click="$router.back()" class="p-1">
            <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
            </svg>
          </button>
          <h1 class="text-lg font-bold text-gray-800 flex-1">🏆 Takas Liderleri</h1>
          <div class="text-xs text-gray-400">Aylık</div>
        </div>
      </div>

      <!-- Zaman Filtresi -->
      <div class="bg-white p-3 border-b border-gray-100">
        <div class="flex gap-2">
          <button 
            @click="timeFilter = 'weekly'"
            :class="[
              'flex-1 py-2 rounded-lg text-sm font-medium transition',
              timeFilter === 'weekly' ? 'bg-takas-sari text-takas-koyu' : 'bg-gray-100 text-gray-600'
            ]"
          >
            Haftalık
          </button>
          <button 
            @click="timeFilter = 'monthly'"
            :class="[
              'flex-1 py-2 rounded-lg text-sm font-medium transition',
              timeFilter === 'monthly' ? 'bg-takas-sari text-takas-koyu' : 'bg-gray-100 text-gray-600'
            ]"
          >
            Aylık
          </button>
          <button 
            @click="timeFilter = 'all'"
            :class="[
              'flex-1 py-2 rounded-lg text-sm font-medium transition',
              timeFilter === 'all' ? 'bg-takas-sari text-takas-koyu' : 'bg-gray-100 text-gray-600'
            ]"
          >
            Tüm Zamanlar
          </button>
        </div>
      </div>

      <!-- İstatistik Özeti -->
      <div class="bg-gradient-to-r from-takas-sari to-yellow-400 p-4">
        <div class="grid grid-cols-3 gap-4 text-center">
          <div>
            <div class="text-2xl font-bold text-takas-koyu">{{ stats.totalTrades }}</div>
            <div class="text-xs text-takas-koyu/80">Toplam Takas</div>
          </div>
          <div>
            <div class="text-2xl font-bold text-takas-koyu">{{ stats.activeUsers }}</div>
            <div class="text-xs text-takas-koyu/80">Aktif Kullanıcı</div>
          </div>
          <div>
            <div class="text-2xl font-bold text-takas-koyu">{{ stats.successRate }}%</div>
            <div class="text-xs text-takas-koyu/80">Başarı Oranı</div>
          </div>
        </div>
      </div>

      <!-- Podyum (İlk 3) -->
      <div class="bg-white p-6">
        <div class="flex items-end justify-center gap-4">
          <!-- 2. -->
          <div class="text-center flex-1">
            <div class="relative">
              <div class="w-16 h-16 rounded-full bg-gradient-to-br from-gray-300 to-gray-400 flex items-center justify-center mx-auto">
                <span class="text-2xl font-bold text-white">2</span>
              </div>
              <div class="absolute -top-3 -right-1 text-yellow-500 text-xl">🥈</div>
            </div>
            <h3 class="font-semibold text-sm mt-2">{{ podium.second.name }}</h3>
            <p class="text-xs text-takas-sari font-bold">{{ podium.second.trades }} takas</p>
            <div class="flex items-center justify-center gap-0.5 mt-1">
              <svg v-for="s in podium.second.rating" :key="s" class="w-3 h-3 text-takas-sari" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
              </svg>
            </div>
          </div>

          <!-- 1. -->
          <div class="text-center flex-1 -mt-4">
            <div class="relative">
              <div class="w-20 h-20 rounded-full bg-gradient-to-br from-takas-sari to-yellow-400 flex items-center justify-center mx-auto shadow-lg">
                <span class="text-3xl font-bold text-takas-koyu">1</span>
              </div>
              <div class="absolute -top-3 -right-1 text-yellow-500 text-2xl">👑</div>
            </div>
            <h3 class="font-bold text-base mt-2">{{ podium.first.name }}</h3>
            <p class="text-xs text-takas-sari font-bold">{{ podium.first.trades }} takas</p>
            <div class="flex items-center justify-center gap-0.5 mt-1">
              <svg v-for="s in podium.first.rating" :key="s" class="w-3 h-3 text-takas-sari" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
              </svg>
            </div>
          </div>

          <!-- 3. -->
          <div class="text-center flex-1">
            <div class="relative">
              <div class="w-16 h-16 rounded-full bg-gradient-to-br from-orange-200 to-orange-300 flex items-center justify-center mx-auto">
                <span class="text-2xl font-bold text-white">3</span>
              </div>
              <div class="absolute -top-3 -right-1 text-yellow-500 text-xl">🥉</div>
            </div>
            <h3 class="font-semibold text-sm mt-2">{{ podium.third.name }}</h3>
            <p class="text-xs text-takas-sari font-bold">{{ podium.third.trades }} takas</p>
            <div class="flex items-center justify-center gap-0.5 mt-1">
              <svg v-for="s in podium.third.rating" :key="s" class="w-3 h-3 text-takas-sari" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- Tüm Liderler Listesi -->
      <div class="p-4 space-y-2">
        <div v-for="(user, index) in filteredLeaders" :key="user.id" 
             @click="goToProfile(user.id)"
             class="bg-white rounded-xl p-3 flex items-center gap-3 cursor-pointer hover:shadow-md transition">
          
          <!-- Sıra -->
          <div class="w-8 text-center">
            <span class="text-lg font-bold" :class="getRankColor(index + 1)">
              {{ index + 1 }}
            </span>
          </div>

          <!-- Avatar -->
          <div class="w-12 h-12 rounded-full bg-gradient-to-br from-takas-sari to-yellow-400 flex items-center justify-center">
            <span class="text-lg font-bold text-takas-koyu">{{ user.initial }}</span>
          </div>

          <!-- Bilgiler -->
          <div class="flex-1">
            <div class="flex items-center gap-2">
              <h3 class="font-semibold text-gray-800">{{ user.name }}</h3>
              <span class="bg-green-100 text-green-600 text-[10px] px-1.5 py-0.5 rounded-full">Doğrulanmış</span>
            </div>
            <div class="flex items-center gap-3 mt-1">
              <div class="flex items-center gap-1">
                <svg class="w-3 h-3 text-takas-sari" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"></path>
                </svg>
                <span class="text-xs">{{ user.rating }}</span>
              </div>
              <span class="text-xs text-gray-400">•</span>
              <span class="text-xs text-gray-500">📦 {{ user.trades }} takas</span>
              <span class="text-xs text-gray-400">•</span>
              <span class="text-xs text-gray-500">⭐ {{ user.successRate }}%</span>
            </div>
          </div>

          <!-- Badge -->
          <div v-if="index === 0" class="text-yellow-500 text-xl">👑</div>
          <div v-else-if="index === 1" class="text-gray-400 text-lg">🥈</div>
          <div v-else-if="index === 2" class="text-orange-400 text-lg">🥉</div>
          <div v-else class="text-gray-300 text-sm">#{{ index + 1 }}</div>
        </div>
      </div>

      <!-- Kendi Sıralaman -->
      <div class="p-4 pb-8">
        <div class="bg-gradient-to-r from-takas-sari/20 to-yellow-400/20 rounded-xl p-4">
          <div class="flex items-center justify-between">
            <div>
              <p class="text-xs text-gray-500">Senin Sıralaman</p>
              <p class="text-2xl font-bold text-takas-koyu">#{{ myRank }}</p>
              <p class="text-xs text-gray-500 mt-1">{{ myTrades }} takas ile {{ myRankText }}</p>
            </div>
            <div class="w-12 h-12 rounded-full bg-takas-sari flex items-center justify-center">
              <span class="text-xl font-bold text-takas-koyu">{{ myInitial }}</span>
            </div>
          </div>
          <div class="mt-3 h-2 bg-white/50 rounded-full overflow-hidden">
            <div class="h-full bg-takas-sari rounded-full" :style="{ width: myProgress + '%' }"></div>
          </div>
          <p class="text-xs text-gray-500 mt-2">Bir sonraki lider için {{ nextRankTrades }} takas daha!</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Leaders',
  data() {
    return {
      timeFilter: 'monthly',
      stats: {
        totalTrades: 12456,
        activeUsers: 3421,
        successRate: 94
      },
      podium: {
        first: { id: 1, name: 'Ahmet Yılmaz', trades: 156, rating: 5, initial: 'A' },
        second: { id: 2, name: 'Mehmet Demir', trades: 128, rating: 5, initial: 'M' },
        third: { id: 3, name: 'Ayşe Kaya', trades: 97, rating: 5, initial: 'A' }
      },
      leaders: [
        { id: 1, name: 'Ahmet Yılmaz', initial: 'A', trades: 156, rating: 5, successRate: 98 },
        { id: 2, name: 'Mehmet Demir', initial: 'M', trades: 128, rating: 5, successRate: 96 },
        { id: 3, name: 'Ayşe Kaya', initial: 'A', trades: 97, rating: 5, successRate: 95 },
        { id: 4, name: 'Can Öztürk', initial: 'C', trades: 84, rating: 4.9, successRate: 94 },
        { id: 5, name: 'Zeynep Yıldız', initial: 'Z', trades: 76, rating: 4.9, successRate: 93 },
        { id: 6, name: 'Burak Aydın', initial: 'B', trades: 68, rating: 4.8, successRate: 92 },
        { id: 7, name: 'Elif Şahin', initial: 'E', trades: 59, rating: 4.8, successRate: 91 },
        { id: 8, name: 'Mustafa Can', initial: 'M', trades: 52, rating: 4.7, successRate: 90 },
        { id: 9, name: 'Selin Ak', initial: 'S', trades: 47, rating: 4.7, successRate: 89 },
        { id: 10, name: 'Ozan Korkmaz', initial: 'O', trades: 41, rating: 4.6, successRate: 88 }
      ],
      myRank: 42,
      myTrades: 12,
      myInitial: 'A',
      myRankText: 'ilk 50 içinde',
      myProgress: 28,
      nextRankTrades: 5
    }
  },
  computed: {
    filteredLeaders() {
      return this.leaders
    }
  },
  methods: {
    getRankColor(rank) {
      if (rank === 1) return 'text-yellow-500'
      if (rank === 2) return 'text-gray-500'
      if (rank === 3) return 'text-orange-500'
      return 'text-gray-400'
    },
    goToProfile(id) {
      this.$router.push(`/profile/${id}`)
    }
  }
}
</script>